<template>
  
</template>
<script>
export default {
  data(){
    return{

    }
  },
  methods:{
    getParams(){
      var url = decodeURI(location.search);
      var object = {};
      if(url.indexOf("?") != -1){
        var str = url.substr(1);
        var strs = str.split("&");
        for(var i = 0; i < strs.length; i ++){
          object[strs[i].split("=")[0]]=strs[i].split("=")[1]
    　　}
        return object;
    　};
    }
  },
  created(){
    var params = new URLSearchParams();
    var rq = this.getParams();
    params.append('openid', rq.openid);
    sessionStorage.setItem("dz",rq.dz)
    sessionStorage.setItem("openid",rq.openid)
    this.axios.post(`/wxAutoLogin/${rq.openid}`)
    .then(res=>{
      if(res.token){
        sessionStorage.setItem("token",res.token);
        sessionStorage.setItem("sjh",res.sjh);
        sessionStorage.setItem("qymc",res.qymc)
        sessionStorage.setItem("qysh",res.qysh)
        if(rq.dz=='bindcompany'&&res.qymc){
          this.$router.replace(`/unbinding`)
        }else if(rq.dz=='bindcompany'&&!res.qymc){
          this.$router.replace(`/bindcompany`)
        }else{
          this.$router.replace(`/${rq.dz}`)
        }
      }else{
        this.$router.replace(`/register`)
      }
    })
  }
}
</script>